module.exports = __webpack_public_path__ + "img/free-state-cheetahs-logo-icon.7bdf231d.png";